import { t } from "i18next";
import { toast } from "sonner";

export default function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD") // Normalize to decomposed form to separate accents from letters
    .replace(/\p{Diacritic}/gu, "") // Remove accents
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/-$/, "")
    .trim();
}

export function sanitizeUpload(text: string): string {
  const dotIndex = text.lastIndexOf(".");
  const hasExt = dotIndex > 0;
  const name = hasExt ? text.slice(0, dotIndex) : text;
  const ext = hasExt ? text.slice(dotIndex) : "";

  const sanitized = name
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[\s-]+/g, "_")
    .replace(/[^\w_]+/g, "")
    .replace(/__+/g, "_")
    .replace(/^_+|_+$/g, "")
    .trim();

  return (sanitized || t("common:file")) + ext.toLowerCase();
}

/**
 * Keeps trailing hyphens so users can type spaces (converted to hyphens)
 * between words without them being stripped while still typing.
 */
export function slugifyInput(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");
}

export const handleSlugErrors = (
  errorList?: Record<string, string[]>[],
): void => {
  if (errorList?.length) {
    errorList.forEach((error) => {
      Object.keys(error).forEach((key) => {
        if (key === "slugs_errors") {
          error[key]?.forEach((errorMessage: string) => {
            const regexp = /slug:(.*), error:(.*)/;
            const match = regexp.exec(errorMessage);
            const duplicateSlug = match?.[1]?.trim();
            const message = match?.[2]?.trim();

            if (message === "duplicate_slug") {
              return toast.error(
                t("error:duplicate_slug", { slug: duplicateSlug }),
              );
            }

            return toast.error(t("editor-platform:saveError"));
          });
        }
      });
    });
  } else {
    toast.error(t("editor-platform:saveError"));
  }
};
